import { render, staticRenderFns } from "./activity-data.vue?vue&type=template&id=6b94b384&scoped=true&"
import script from "./activity-data.vue?vue&type=script&lang=ts&"
export * from "./activity-data.vue?vue&type=script&lang=ts&"
import style0 from "./activity-data.vue?vue&type=style&index=0&id=6b94b384&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b94b384",
  null
  
)

export default component.exports